<template>
  <table>
    <thead>
    <tr v-if="$route.path.includes('invoice')">
      <td :class="isInvoiceListPath ? 'td-active' : ''">
        <a :class="isInvoiceListPath ? 'a-active' : 'a-not-active'" @click="selectInvoiceList">
          <span class="name">{{ $t('nav.listOfInvoices') }}</span>
        </a>
      </td>

      <td :class="isInvoiceNewPath ? 'td-active': ''">
        <a :class="isInvoiceNewPath ? 'a-active' : 'a-not-active'" @click="selectInvoiceNew">
          <span class="name">{{ $t('nav.createNewInvoice') }}</span>
        </a>
      </td>

      <td :class="isInvoiceHistoryPath ? 'td-active': ''">
        <a :class="isInvoiceHistoryPath ? 'a-active' : 'a-not-active'" @click="selectInvoiceHistory">
          <span class="name">{{ $t('nav.invoicesHistory') }}</span>
        </a>
      </td>
    </tr>

    <tr v-else-if="$route.path.includes('terminal')">
      <td :class="isTerminalListPath ? 'td-active' : ''">
        <a :class="isTerminalListPath ? 'a-active' : 'a-not-active'" @click="selectTerminalList">
          <span class="name">{{ $t('nav.listOfTerminals') }}</span>
        </a>
      </td>

      <td :class="isTerminalHistoryPath ? 'td-active': ''">
        <a :class="isTerminalHistoryPath ? 'a-active' : 'a-not-active'" @click="selectTerminalHistory">
          <span class="name">{{ $t('nav.terminalsHistory') }}</span>
        </a>
      </td>
    </tr>

    <tr v-else>
      <td :class="isClubTransferHistoryPath ? 'td-active' : ''">
        <a :class="isClubTransferHistoryPath ? 'a-active' : 'a-not-active'" @click="selectClubTransferHistory">
          <span class="name">{{ $t('nav.history') }}</span>
        </a>
      </td>
    </tr>
    </thead>
  </table>
</template>

<script>
  export default {
    name: 'SubNavigation',
    computed: {
      isInvoiceListPath() {
        return this.$route.path === '/club/invoice/list';
      },
      isInvoiceNewPath() {
        return this.$route.path === '/club/invoice/new';
      },
      isInvoiceHistoryPath() {
        return this.$route.path === '/club/invoice/transactions';
      },
      isTerminalListPath() {
        return this.$route.path === '/club/terminal/list';
      },
      isTerminalHistoryPath() {
        return this.$route.path === '/club/terminal/history';
      },
      isClubTransferHistoryPath() {
        return this.$route.path === '/club/transfers';
      },
    },
    methods: {
      selectInvoiceList() {
        this.$router.push('/club/invoice/list');
      },
      selectInvoiceNew() {
        this.$router.push('/club/invoice/new');
      },
      selectInvoiceHistory() {
        this.$router.push('/club/invoice/transactions');
      },
      selectTerminalList() {
        this.$router.push('/club/terminal/list');
      },
      selectTerminalHistory() {
        this.$router.push('/club/terminal/history');
      },
      selectClubTransferHistory() {
        this.$router.push('/club/transfers');
      },
    },
  }
</script>

<style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    display: table;
    text-align: left;
    font-family: Verdana, sans-serif;
    color: #000;
  }

  tbody {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    display: table-row-group;
    border-collapse: collapse;
    border-spacing: 0;
    text-align: left;
    color: #000;
  }

  tr {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    display: table-row;
    border-collapse: collapse;
    border-spacing: 0;
    text-align: left;
    font-family: Verdana, sans-serif;
    color: #000;
    min-height: 36px;
  }

  td {
    text-align: center;
    border-right: 1px solid #fff;
    border-bottom: 1px solid #fff;
    line-height: 19px;
    white-space: nowrap;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    display: table-cell;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: Verdana, sans-serif;
    color: #000;
  }

  .td-active {
    border-bottom: 1px solid #d3e2f0;
    text-align: center;
    border-right: 1px solid #fff;
    line-height: 19px;
    white-space: nowrap;
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    display: table-cell;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: Verdana, sans-serif;
    color: #000;
  }

  .a-not-active {
    text-decoration: underline;
    display: block;
    padding: 0px 10px;
    padding-top: 7px;
    padding-bottom: 0px;
    height: 28px;
    font-size: 15px;
    background: #eaecea;
    color: #666666;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin: 0;
    border: 0;
    font-style: normal;
    outline: 0;
    cursor: pointer;
    text-align: center;
    line-height: 19px;
    white-space: nowrap;
    border-collapse: collapse;
    border-spacing: 0;
  }

  .a-not-active:hover {
    color: #a3a3a3;
    display: block;
    padding: 0px 10px;
    padding-top: 7px;
    padding-bottom: 0px;
    height: 28px;
    font-size: 15px;
    background: #eaecea;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    text-decoration: underline;
    margin: 0;
    border: 0;
    font-style: normal;
    outline: 0;
    cursor: pointer;
    text-align: center;
    line-height: 19px;
    white-space: nowrap;
  }

  .a-active {
    color: #000;
    background: #d3e2f0;
    text-decoration: none;
    display: block;
    padding: 0px 10px;
    padding-top: 7px;
    padding-bottom: 0px;
    height: 28px;
    font-size: 15px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    margin: 0;
    border: 0;
    font-style: normal;
    outline: 0;
    cursor: pointer;
    text-align: center;
    line-height: 19px;
    white-space: nowrap;
    border-collapse: collapse;
    border-spacing: 0;
    font-family: Verdana, sans-serif;
  }
</style>
